import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface NavListItemProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** Primary line — the item label. */
  label: ReactNode;
  /** Optional secondary line — mono-ish meta (e.g. "4 members"). */
  meta?: ReactNode;
  /** Selected state — applies the active wash + `aria-current="true"`. */
  selected?: boolean;
}

/**
 * Selectable two-line list row for settings sub-navigation lists (the left
 * column of two-column settings pages — function roles, permission groups, …).
 * Hairline-separated, hover wash, active wash on `selected`. Mirrors the
 * `.role-list li` shape in the web-mock settings partials.
 */
export function NavListItem({
  label,
  meta,
  selected,
  className,
  ...rest
}: NavListItemProps) {
  const cls = ['pn-nav-list-item', className].filter(Boolean).join(' ');
  return (
    <button
      type="button"
      className={cls}
      data-selected={selected ? 'true' : 'false'}
      aria-current={selected ? 'true' : undefined}
      {...rest}
    >
      <span className="pn-nav-list-item-label">{label}</span>
      {meta != null ? (
        <span className="pn-nav-list-item-meta">{meta}</span>
      ) : null}
    </button>
  );
}
